// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3Wm_A","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2-mpx"};